import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Table, Tag, ConfigProvider, theme } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faCircleInfo,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useUserContext } from "../../context";
import { colors } from "../../devdata/constants/themes";
import { Subhai } from "..";
import { whaticonstocks } from "../../devdata/maps/whaticon";
import { stocks } from "../../devdata/maps/chartred";
import PiScoreTag from "../piScoreTag"
const Daystocks = ({ big }: { big: boolean }) => {
  const { daystocks, setdaystocks, sub, isDhanLogged, dhanToken } = useUserContext();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [favtrig, setfavtrig] = useState(false);
  const [favwhat, setfavwhat] = useState(0);

  const [favorites, setFavorites] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [priceSortOrder, setPriceSortOrder] = useState<"descend" | "ascend">(
    "descend"
  );

  const [marketCapSortOrder, setMarketCapSortOrder] = useState<
    "descend" | "ascend"
  >("descend");
  const sortStocks = (key, direction) => {
    const sorted = [...filteredData].sort((a, b) => {
      const aValue = a[key];
      const bValue = b[key];
      return direction === "ascend" ? aValue - bValue : bValue - aValue;
    });
    setFilteredData(sorted);
  };

  const handlefavtrig = (what) => {
    setfavtrig(true);
    setfavwhat(what);
    setTimeout(() => setfavtrig(false), 2000);
  };

  const getISTDateTime = () => {
    let now = new Date();
    now.setUTCHours(now.getUTCHours() + 5);
    now.setUTCMinutes(now.getUTCMinutes() + 30);
    now.setUTCSeconds(0); // Set seconds to 00

    let date = now.toISOString().split("T")[0]; // Extract YYYY-MM-DD
    let time =
      now.toISOString().split("T")[1].split(".")[0].slice(0, -2) + "00"; // Extract HH:mm:00

    return { date, time };
  };
  const toggleFavorite = (key, event) => {
    event.stopPropagation();

    setFavorites((prev) => {
      const updated = new Set(prev);
      if (updated.has(key)) {
        updated.delete(key);
        handlefavtrig(0);
      } else {
        updated.add(key);
        handlefavtrig(1);
      }
      return updated;
    });
    setdaystocks((prev) => {
      if (prev.includes(key)) {
        return prev.filter((stock) => stock !== key);
      } else {
        return [...prev, key];
      }
    });
  };
  useEffect(() => {
    setFilteredData(data);
  }, [data]);
  useEffect(() => {
    try {
      const d = sessionStorage.getItem("all");
      if (d) {
        const parseddata = JSON.parse(d);

        // console.log(daystocks);
        if (daystocks.length > 0) {
          const { date: currentDate, time: currentTime } = getISTDateTime();

          const newdata = daystocks
            .map((ncode) => {
              let stock = parseddata.find((stock) => stock.nsecode === ncode);

              if (!stock) return null; // Skip if stock not found

              const suggestion =
                stock.pil >= 14
                  ? "Good to Enter"
                  : stock.pil >= 10
                    ? "Watchlist"
                    : "None";

              stock = { ...stock, suggestion };

              const match = stocks.find((dat) => dat.name === stock.name);
              if (match) {
                return { ...stock, sector: match.sector }; // Add sector if match found
              } else {
                return { ...stock, sector: "Indices" }; // Return original stock if no match
              }
            })
            .filter(Boolean); // Remove null values

          setData(newdata);
          setFavorites(new Set(newdata.map((stock) => stock.nsecode)));
        } else {
          setData([]);
          setFavorites(new Set());
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [daystocks]);

  const columns = [
    {
      title: "",
      width: big ? "2%" : "10%",
      dataIndex: "nsecode",
      key: "favorite",
      render: (key) => (
        <div
          className="p-2 cursor-pointer flex items-center justify-center"
          onClick={(e) => toggleFavorite(key, e)}
        >
          <FontAwesomeIcon
            icon={faStar}
            className={`${favorites.has(key) ? "text-yellow-500" : "text-darkMode-layer3"
              }`}
          />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: big ? 400 : 230, // Increased fixed width for Stock name + icon
      render: (text, record) => (
        <div className="flex items-center gap-2">
          {whaticonstocks[record.name] ? (
            <img
              src={whaticonstocks[record.name]}
              alt="stock icon"
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <div className="w-8 h-8 bg-darkMode-layer3 rounded-full flex items-center justify-center">
              <span className="text-darkMode-text text-xl">?</span>
            </div>
          )}
          <span
            className="cursor-pointer"
            onClick={() => {
              const found = stocks.find(
                (stock) => stock.nsecode === record.nsecode
              );
              const foundUrl = isDhanLogged ? found?.dhanUrl?.replace("123GOFREE", dhanToken) : found?.url || found?.url
              if (foundUrl) {
                window.open(foundUrl, "_blank");
              } else {
                console.error("URL not found");
              }
            }}
          >
            {text}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center">
          <FontAwesomeIcon
            icon={priceSortOrder === "ascend" ? faArrowUp : faArrowDown}
            className="mr-2 cursor-pointer"
            onClick={() => {
              const newOrder =
                priceSortOrder === "ascend" ? "descend" : "ascend";
              setPriceSortOrder(newOrder);
              sortStocks("close", newOrder);
            }}
          />
          <span>Price</span>
        </div>
      ),
      dataIndex: "close",
      key: "close",
      // align: "center",

      render: (text) => (
        <div>
          {text.toFixed(2)}
          {/* <span style={{ fontSize: "0.8rem" }}> INR</span> */}
        </div>
      ),
    },
    {
      title: "% Change",
      dataIndex: "per_chg",
      key: "per_chg",
      align: "center",
      render: (text) => (
        <div className="px-2 py-1 -mx-3 flex justify-center w-[calc(100%+24px)]">
          <Tag
            className={`rounded-full bg-darkMode-layer3 text-sm text-center min-w-[65px] ${text > 0 ? "text-green-500" : "text-red-500"
              }`}
          >
            {text}%
          </Tag>
        </div>
      ),
    },

    ...(big
      ? [
        {
          title: "Pi Score",
          dataIndex: "pil",
          key: "pil",
          align: "center",
          render: (text) => <PiScoreTag value={text} />,
        },
        {
          title: "Sector",
          dataIndex: "sector",
          key: "sector",
        },
        {
          title: <span className="text-xs sm:text-sm">Suggestion</span>,
          dataIndex: "pil",
          key: "good",
          align: "center",
          width: 120, // Adjusted width, needs enough space for the tag
          render: (piScore) => {
            let text = "Ignore";
            let bgColor = "bg-red-500/80";
            let textColor = "text-white";
            let icon = null;

            if (typeof piScore === "number") {
              if (piScore >= 14) {
                text = "Good to Enter";
                bgColor = "bg-darkMode-green/20";
                textColor = "text-darkMode-green";
              } else if (piScore >= 10) {
                text = "Watchlist";
                bgColor = "bg-yellow-500/30";
                textColor = "text-yellow-400";
              }
            }

            return (
              <div className="flex items-center justify-center w-full px-1">
                <div
                  className={`flex items-center justify-center rounded-full text-xs font-semibold border-0 px-2 py-0.5 text-center whitespace-nowrap min-w-[70px] ${bgColor} ${textColor}`}
                >
                  <span>{text}</span>
                </div>
                {/* <FontAwesomeIcon
                    icon={faCircleInfo}
                    color="#6A6A6A"
                    className="ml-2 text-xs sm:text-sm md:text-base"
                  /> */}
              </div>
            );
          },
        },
      ]
      : []),
  ];

  return (
    <>
      {big && (
        <div className="flex flex-row items-center justify-between  text-xl md:text-2xl font-semibold text-darkMode-text px-4 md:px-0 mt-2 mb-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            My <span className="text-market-teal">Watchlist</span>
          </h1>
        </div>
      )}
      <div className="bg-darkMode-layer1 rounded-xl p-4 overflow-hidden flex flex-col">
        {!big && (
          <div className="flex flex-row items-center justify-between text-lg font-medium text-darkMode-text">
            <div>My Watchlist</div>
          </div>
        )}
        <div className="flex flex-col">
          <div className={`mt-4 relative ${sub?.issubexp ? "h-[400px]" : ""}`}>
            <ConfigProvider
              theme={{
                token: {
                  colorBgContainer: colors.darkMode.layer2,
                },
                algorithm: theme.darkAlgorithm,
              }}
            >
              {loading ? (
                <p className="text-center text-darkMode-text">Loading...</p>
              ) : data.length === 0 ? (
                <div className="flex flex-col items-center justify-center p-6 text-center">
                  <img
                    alt="myday"
                    src={require("../../devdata/icons/mydayplus.png")}
                    className="text-darkMode-text w-12 h-auto"
                  />
                  <p className="text-darkMode-subText text-md md:text-xl">
                    You have not added any stock in <br /> your watchlist, add
                    stocks in list!
                  </p>
                  <Link to="/PiScanner">
                    <button className="mt-3 bg-darkMode-layer2 text-darkMode-text px-4 py-2 rounded-lg text-sm md:text-base hover:bg-darkMode-layer3">
                      Go to Pi Scanner
                    </button>
                  </Link>
                </div>
              ) : (
                <div className="rounded-lg overflow-x-auto bg-darkMode-layer2">
                  <Table
                    dataSource={filteredData}
                    showHeader={true}
                    rowKey="nsecode"
                    columns={columns}
                    pagination={{
                      defaultPageSize: big ? 10 : 5,
                      total: filteredData.length,
                      responsive: true,
                      showSizeChanger: false,
                      className: "pt-3",
                    }}
                    className="w-full shadow-sm text-darkMode-text"
                    rowClassName="cursor-default"
                    bordered={false}
                    tableLayout="fixed"
                    style={{ background: colors.darkMode.layer2 }}
                    scroll={{ x: "max-content" }}
                  />
                </div>
              )}
              <Subhai />
            </ConfigProvider>
          </div>
        </div>
      </div>

      {favtrig && big && (
        <div className="absolute inset-0 flex items-center justify-center">
          <p
            className="text-white text-sm rounded-md p-3 text-center"
            style={{
              width: 200,
              backgroundColor: favwhat === 0 ? "red" : "green",
            }}
          >
            <FontAwesomeIcon icon={faCircleCheck} color="white" />{" "}
            {favwhat === 0 ? "Removed from" : "Added to"} the list
          </p>
        </div>
      )}
    </>
  );
};

export default Daystocks;
